module.exports = __webpack_public_path__ + "static/img/ad9a10ab.c10.dcbb6e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/ad9a10ab.c10.jpg
// module id = ajVQ
// module chunks = 2